import { Grid, Box, useMediaQuery } from "@mui/material";
import BuilderDocumentCard from "./BuilderDocumentCard";
import CustomPagination from "../../../../PotatoProtection/LargeScreen/Landing/CustomPagination";
import { useMemo, useState } from "react";

const DocumentList = ({
  data,
  label,
  type,
  pageType = "FORUM_BUILDER",
  handleDeleteContent,
}) => {
  const isMobile = useMediaQuery("(max-width:800px)");
  const [page, setPage] = useState(0);
  const itemsPerPage = 10;

  // Calculate paginated data
  const paginatedRows = useMemo(() => {
    return data?.slice(page * itemsPerPage, (page + 1) * itemsPerPage);
  }, [data, page, itemsPerPage]);

  // Calculate total pages
  const totalPages = useMemo(() => {
    const total = Math.ceil(data?.length / itemsPerPage);
    return total > 0 ? total : 1;
  }, [data?.length, itemsPerPage]);

  return (
    <>
      {isMobile ? (
        <Grid container spacing={2} className="builder">
          {paginatedRows?.map((item) => (
            <Grid item key={item.contentId} xs={12} sm={6} md={4}>
              <BuilderDocumentCard
                item={item}
                type={type}
                abel={label}
                key={item.contentId}
                page={pageType}
                handleDeleteContent={handleDeleteContent}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Box
          className="builder"
          sx={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: "16px",
            justifyContent: "flex-start",
          }}
        >
          {paginatedRows?.map((item) => (
            <BuilderDocumentCard
              key={item.contentId}
              item={item}
              label={label}
              type={type}
              page={pageType}
              handleDeleteContent={handleDeleteContent}
            />
          ))}
        </Box>
      )}
      {data.length > 0 && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            alignSelf: "stretch",
            border: "1px solid #DFDFDF",
          }}
        />
      )}

      {data.length > 0 && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: "16px",
            width: "100%",
          }}
        >
          <CustomPagination
            page={page}
            setPage={setPage}
            totalPages={totalPages}
          />
        </Box>
      )}

      {/* Content goes here */}
    </>
  );
};

export default DocumentList;
